// document.addEventListener('DOMContentLoaded', function () {

//     function resetAllVideos() {
//       document.querySelectorAll('.js-video-wrapper').forEach(wrapper => {
//         const thumb = wrapper.querySelector('.js-video-thumb');
//         const videoContainer = wrapper.querySelector('.js-video-container');
//         const video = wrapper.querySelector('video');

//         if (video) {
//           video.pause();
//           video.currentTime = 0;
//         }

//         if (thumb) thumb.style.display = 'block';
//         if (videoContainer) videoContainer.style.display = 'none';
//       });
//     }

//     document.addEventListener('click', function (e) {
//       const thumb = e.target.closest('.js-video-thumb');
//       if (!thumb) return;

//       resetAllVideos(); // 🔥 close all other videos

//       const wrapper = thumb.closest('.js-video-wrapper');
//       const videoContainer = wrapper.querySelector('.js-video-container');
//       const video = wrapper.querySelector('video');

//       thumb.style.display = 'none';
//       videoContainer.style.display = 'block';

//       if (video) {
//         video.play();
//       }
//     });

//     /* 🔁 Stop video on slide change */
//     document.querySelectorAll('.splide').forEach(splideEl => {
//       splideEl.addEventListener('splide:move', resetAllVideos);
//     });

//   });
// for faq
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a.FAQs').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const faqSelector = '.section.section--page-width.faq';
      const faqSection = document.querySelector(faqSelector);

      if (faqSection) {
        // FAQ exists on current page
        faqSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } else {
        // FAQ not found, redirect to home with hash
        // window.location.href = '/' + '#faq-section';
          window.open('/#faq-section', '_blank');
      }
    });
  });

  if (window.location.hash === '#faq-section') {
    const faqSection = document.querySelector('.section.section--page-width.faq');
    if (faqSection) {
      setTimeout(function () {
        faqSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 300);
    }
  }
  // for testimonail page
  // Run only on testimonials page (handles trailing slash too)
  if (!window.location.pathname.startsWith('/pages/testimonials')) return;
    console.log("1")

  const hash = window.location.hash;
  if (!hash) return;
    console.log("123")

  const tag = hash.substring(1); // remove #
  const tabsWrapper = document.querySelector('.story-tabs');
  if (!tabsWrapper) return;

  const targetTab = tabsWrapper.querySelector(`.tab[data-tag="${tag}"]`);
  if (!targetTab) return; // invalid tag, do nothing
    console.log("2")

  // Activate tab
  tabsWrapper.querySelectorAll('.tab').forEach(tab => {
    tab.classList.remove('active');
    console.log("3")
  });

  targetTab.classList.add('active');

  // Trigger existing tab click logic (filters, ajax, etc.)
  targetTab.dispatchEvent(new Event('click', { bubbles: true }));

  // Smooth scroll to happy-stories section
  const targetSection = document.querySelector('.happy-stories .subheading');
  if (targetSection) {
    setTimeout(() => {
      targetSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 300); // small delay so tab content loads first
  }
});
